import React, { Component } from 'react';
import logo from './logo.svg';
import axios from 'axios';
import './Draft.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { CustomNav } from '../Components/CustomNav';
import { ProspectCard } from '../Components/ProspectCard';
import { PlayerComparable } from '../Components/PlayerComparable';
import { DraftTable } from '../Components/DraftTable';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import deleteLogo from '../Assets/icons_exit.png';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
//let prospects = require('../Mock/draft-prospect-list-na.json');
//let prospects = require('../Mock/prospects.json');
export class Draft extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prospects: '',
      selectedPlayer: '',
      playerList: [],
      selectedPlayerScouting: null,
      draftLists: [],
      year: 2020
    };
    this.toggleActive = this.toggleActive.bind(this);
    this.saveList = this.saveList.bind(this);
    this.loadLists = this.loadLists.bind(this);
    this.modifyDraftList = this.modifyDraftList.bind(this);
    this.state.selectedPlayer = this.state.prospects[0];
  }
  componentDidMount(props) {
    let currentComponent = this;
    // Make a request for a user with a given ID
    axios
      .get(apiServerUrl + '/prospects?year=2020', requestOptions())
      .then(function(response) {
        ////console.log(response);
        ////console.log("remote players "  + response.data.players);
        currentComponent.setState({
          prospects: response.data.players
          //selectedPlayer: response.data.players[0]
        });
      })
      .catch(function(error) {
        //console.log(error);
      });
  }
  removeListItem(id) {
    const newState = this.state;
    const index = newState.playerList.findIndex(a => a.playerID === id);
    if (index === -1) return;
    newState.playerList.splice(index, 1);
    this.setState(newState);
    //console.log("removing data" + id);
    let row = document.getElementById(id + '-listItem');
    //console.log("removing data" + row);
    //row.parentNode.removeChild(row);
  }
  loadList(item, listID) {
    console.log('load list');
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/load_draft_list?listID=' + listID, requestOptions())
      .then(function(response) {
        console.log(response.data);
        currentComponent.setState({
          draftLists: [],
          playerList: [
            {
              biographical: {
                currentAge: 18,
                firstName: 'Rasmus',
                lastName: 'Dahlin'
              },
              henri: 'Blue',
              playerID: 310545
            }
          ]
        });
      });
  }
  loadLists(data) {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/load_draft_lists', requestOptions())
      .then(function(response) {
        console.log(response.data);
        currentComponent.setState({
          playerList: [],
          draftLists: [
            { description: 'example list', date: 'yesterday', user: 'steve' }
          ]
        });
      });
  }
  saveList(data) {
    //const newState = this.state;
    //console.log(newState);
    //his.state
    //console.log("data" + data);
    let currentComponent = this;
    let playerList = currentComponent.state.playerList;

    console.log(playerList);
    axios
      .post(
        apiServerUrl + '/save_draft_list',
        currentComponent.state.playerList,
        requestOptions()
      )
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  toggleActive(data) {
    //console.log("data" + data);
    let currentComponent = this;
    let test = this.state.prospects.find(x => x.playerID == data);
    console.log(test);
    axios
      .get(
        apiServerUrl + '/prospect_report_summary?playerid=' + test.playerID,
        requestOptions()
      )
      .then(function(response) {
        console.log(response.data, typeof response.data);
        if (typeof response.data === 'object') {
          currentComponent.setState({
            selectedPlayerScouting: response.data
          });
        } else if (typeof response.data === 'string') {
          currentComponent.setState({
            selectedPlayerScouting: null
          });
        }
      })
      .catch(function(error) {
        //console.log(error);
      });
    test.children = '';
    this.setState({
      selectedPlayer: test
    });
  }
  modifyDraftList() {
    //console.log("data" + this.state.selectedPlayer);
    let test = this.state.playerList.find(
      x => x.playerID == this.state.selectedPlayer.playerID
    );
    if (test) {
      //console.log("DUPLICATE");
      return false;
    }
    //test.children = '';
    let player = this.state.selectedPlayer;
    let playerList = this.state.playerList;
    playerList.push(player);
    console.log(JSON.stringify(playerList));
    this.setState({
      draftLists: [],
      playerList: playerList
    });
    //console.log("playerList after" + this.state.playerList);
  }

  yearCallback = year => {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/prospects?year=' + year, requestOptions())
      .then(function(response) {
        console.log(response);
        currentComponent.setState({
          prospects: response.data.players,
          year: year
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        <div
          className="flex-grid"
          style={{ flexDirection: 'row', alignItems: 'stretch' }}
        >
          <main className="main" style={{ flex: 5, outline: 'none' }}>
            {this.state.prospects && (
              <DraftTable
                toggleActive={this.toggleActive}
                prospects={this.state.prospects}
                yearCallback={this.yearCallback}
              />
            )}
          </main>

          <div className="side2">
            <h3 style={{ textAlign: 'center', color: 'white' }}>DRAFT LIST</h3>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              {/*}<button class="button">My List</button>*/}
              <button class="button" onClick={this.loadLists}>
                Load List
              </button>
              <button class="button" onClick={this.saveList}>
                Save
              </button>
            </div>
            <ol
              id="myList"
              style={{ listStyleType: 'none', textAlign: 'left', padding: '0' }}
            >
              {this.state.draftLists &&
                this.state.draftLists.map(list => (
                  <li
                    id={list.listID + '-listItem'}
                    onClick={this.loadList.bind(this, list.listID)}
                  >
                    {list.user}-{list.description}-{list.date}
                    {/*}<span
                    onClick={this.removeListItem.bind(this, list.playerID)}
                    style={{ float: 'right' }}
                  >
                    <img
                      src={deleteLogo}
                      alt="Delete"
                      width="20"
                      height="20"
                    />
                  </span>*/}
                  </li>
                ))}
              {this.state.playerList &&
                this.state.playerList.map(tile => (
                  <li id={tile.playerID + '-listItem'}>
                    {tile.biographical.firstName} {tile.biographical.lastName}{' '}
                    <span
                      onClick={this.removeListItem.bind(this, tile.playerID)}
                      style={{ float: 'right' }}
                    >
                      <img
                        src={deleteLogo}
                        alt="Delete"
                        width="20"
                        height="20"
                      />
                    </span>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div className="flex-grid">
          <div
            className="comparison"
            style={{ flex: 2, borderRadius: '5px', outline: 'none' }}
          >
            {this.state.selectedPlayer && (
              <PlayerComparable
                selectedPlayer={this.state.selectedPlayer}
                toggleActive={this.toggleActive}
                year={this.state.year}
              />
            )}
          </div>
          <div className="player" style={{ flex: 3, outline: 'none' }}>
            {this.state.selectedPlayer && (
              <ProspectCard
                modifyDraftList={this.modifyDraftList}
                selectedPlayer={this.state.selectedPlayer}
                selectedPlayerScouting={this.state.selectedPlayerScouting}
                scout={false}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Draft;



// WEBPACK FOOTER //
// ./src/Pages/Draft.js